export const isStaffingRatioUnhealthy = (
  ratio: number,
  delta: number
): boolean => {
  const isInHealthyRange = ratio >= 1.3 && ratio <= 2.5;
  if (isInHealthyRange) return false;

  const isAboveHealthyRange = ratio > 2.5;
  const isBelowHealthyRange = ratio < 1.3;

  if (isAboveHealthyRange) return delta > 0;
  if (isBelowHealthyRange) return delta < 0;

  return false;
};
